import { PROFILE_FISCAL, PROFILE_OGA, PROFILE_SISTEMAS } from "../data/profiles";

const { JUECES_LISTAR, FUNCIONARIOS_LISTAR, INHIBICIONES_LISTAR, TURNOS_LISTAR, RECUSACIONES_LISTAR, LICENCIAS_LISTAR, USUARIOS_LISTAR, NIVELES_MODIFICAR, OFIJUS_LISTAR, UNIDADES_LISTAR, PARAMETROS_LISTAR, TURNOS_ELIMINAR, REPORTES_VER } = require("../data/objects");

class AuthoritiesService {

    hasPermission(authorities, object)
    {
        //Verifico
        if(authorities.find(a => a === object)){
            return true;
        }
        //Por defecto no hay permisos
        return false;
    }

    hasInterfaces(authorities){
        //Personas
        if(this.hasPersons(authorities)){
            return true;
        }
        //Utilidades
        if(this.hasUtilities(authorities)){
            return true;
        }
        //Reportes
        if(authorities.find(a => a === REPORTES_VER)){
            return true;
        }
        //Por defecto no hay permisos
        return false;
    }

    hasConfig(authorities){
        //Parametros
        if(this.hasParameters(authorities)){
            return true;
        }
        //Admin
        if(this.hasAdmin(authorities)){
            return true;
        }
        //Por defecto no hay permisos
        return false;
    }

    hasPersons(authorities){
        //Jueces
        if(authorities.find(a => a === JUECES_LISTAR)){
            return true;
        }
        //Funcionarios
        if(authorities.find(a => a === FUNCIONARIOS_LISTAR)){
            return true;
        }
        //Por defecto no hay permisos
        return false;
    }

    hasUtilities(authorities){
        //Inhibiciones
        if(authorities.find(a => a === INHIBICIONES_LISTAR)){
            return true;
        }
        //Turnos
        if(authorities.find(a => a === TURNOS_LISTAR)){
            return true;
        }
        //Recusaciones
        if(authorities.find(a => a === RECUSACIONES_LISTAR)){
            return true;
        }
        //Licencias
        if(authorities.find(a => a === LICENCIAS_LISTAR)){
            return true;
        }
        //Por defecto no hay permisos
        return false;
    }

    hasParameters(authorities){
        //Parámetros
        if(authorities.find(a => a === PARAMETROS_LISTAR)){
            return true;
        }
        //Por defecto no hay permisos
        return false;
    }

    hasAdmin(authorities){
        //Usuarios
        if(authorities.find(a => a === USUARIOS_LISTAR)){
            return true;
        }
        //Niveles
        if(authorities.find(a => a === NIVELES_MODIFICAR)){
            return true;
        }
        //Ofijus
        if(authorities.find(a => a === OFIJUS_LISTAR)){
            return true;
        }
        //Unidades
        if(authorities.find(a => a === UNIDADES_LISTAR)){
            return true;
        }
        //Por defecto no hay permisos
        return false;
    }

    hasReports(authorities, user){
        //Reportes
        if(authorities.find(a => a === REPORTES_VER)){
            //Me fijo que tenga perfil
            if(user && (user.perfil.id === PROFILE_SISTEMAS || user.perfil.id === PROFILE_OGA || user.perfil.id === PROFILE_FISCAL)){
                return true;
            }
        }
        //Por defecto no hay permisos
        return false;
    }
}

export default new AuthoritiesService();